export { default } from './Notices';
